import CFDomainSidebar from '#modules/domains/components/CFDomainSidebar.vue';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';
import enforceTwoFactor from '@/app/router/middleware/enforceTwoFactor.js';
import ensureUserIsVerified from '@/app/router/middleware/ensureUserIsVerified.js';
import { defineModule } from '@/app/router/defineModule.ts';
import { AppPermissions } from '#modules/auth/constants/permissions.js';

export default defineModule({
    name: 'domains',
    routes: [
        {
            path: '/domains',
            name: 'domains',
            component: () => import('#modules/domains/pages/index.vue'),
            meta: {
                layout: 'app',
                permissions: [AppPermissions.ManageDomains],
            },
        },
        {
            path: '/domain',
            meta: {
                layout: 'app-sidebar',
                sidebar: CFDomainSidebar,
                permissions: [AppPermissions.ManageDomains],
                middleware: [shouldBeAuthenticated, enforceTwoFactor, ensureUserIsVerified],
            },
            children: [
                {
                    path: ':domain',
                    name: 'single domain',
                    component: () => import('#modules/domains/pages/show.vue'),
                },
                {
                    path: ':domain/dns',
                    name: 'domain dns',
                    component: () => import('#modules/domains/pages/dns.vue'),
                },
                {
                    path: ':domain/nameservers',
                    name: 'domain nameservers',
                    component: () => import('#modules/domains/pages/nameservers.vue'),
                },
                {
                    path: ':domain/activity-log',
                    name: 'domain activity log',
                    component: () => import('#modules/domains/pages/activity-log.vue'),
                },
            ],
        },
    ],
});
